<section id="performance-fees">
    <div class="container" id="performance-fees_section">
        <div class="row">
            <div class="col-xs-4 col-sm-12">
                <h2 class="rps-heading-two" id="performance-fees_header">Performance & fees</h2>
                <h5 class="total-returns rps-heading-five">Total returns</h5>
            </div>
            <div class="col-xs-4 col-sm-12">
              <c11n-tabs activeItem="" variant="left-aligned" (activeItemChange)="onTabSelection($event)" overflowOption="nav-overflow" hasAnimation="true">
                <c11n-tab-panel data-rpa-tag-id="pf-tr-summaryTab" id="summary" labelText="Summary">
                  <div class="c11n-text-crop">
                    <performance-summary [data]="performanceModel?.performance" [profileData]="performanceModel?.profileData" [marketPriceFootNote]="performanceModel?.marketPriceFootNote" [benchmarkFootNote]="performanceModel?.benchmarkFootnote" [performanceFootNote]="performanceModel?.performanceFootnote"></performance-summary>
                </div>
                </c11n-tab-panel>
                <c11n-tab-panel data-rpa-tag-id="pf-tr-quaterlyTab" id="quarterly" labelText="Quarterly" *ngIf="performanceModel?.profileData.isInternal">
                  <div class="c11n-text-crop">
                    <performance-quarterly [data]="performanceModel?.performance?.quarterlyRtn" [profileData]="performanceModel?.profileData" [marketPriceFootNote]="performanceModel?.marketPriceFootNote" [benchmarkFootNote]="performanceModel?.benchmarkFootnote"
                        ></performance-quarterly>
                </div>
                </c11n-tab-panel>
                <c11n-tab-panel data-rpa-tag-id="pf-tr-annuallyTab" id="annually" labelText="Annually">
                  <div class="c11n-text-crop">
                    <performance-annually [data]="performanceModel?.performance?.annualRtn" [profileData]="performanceModel?.profileData" [marketPriceFootNote]="performanceModel?.marketPriceFootNote" [benchmarkFootNote]="performanceModel?.benchmarkFootnote"></performance-annually>
                </div>
                </c11n-tab-panel>
                <c11n-tab-panel data-rpa-tag-id="pf-tr-cumulativeTab" id="cumulative" labelText="Cumulative" *ngIf="performanceModel?.profileData.isInternal">
                  <div class="c11n-text-crop">
                    <performance-cumulative [isSmallScreen]="isSmallScreen" [data]="performanceModel?.performance?.cummulativeRtn" [profileData]="performanceModel?.profileData" [marketPriceFootNote]="performanceModel?.marketPriceFootNote" [benchmarkFootNote]="performanceModel?.benchmarkFootnote" [performanceFootNote]="performanceModel?.performanceFootnote"></performance-cumulative>
                </div>
                </c11n-tab-panel>
              </c11n-tabs>
            </div>

        </div>
        <div class="row after-tax" *ngIf="!performanceModel?.profileData?.is529 && !(performanceModel?.profileData?.isETF && performanceModel?.profileData?.isExternal)">
            <div class="col-sm-12">
              <c11n-accordion
                class="d-block"
                [headingLevel]="4"
                (stateChange)="logAccordionValue($event)"
                [labelText]="'Quarterly after-tax returns'"
                [size]="isLargeScreen ? 'medium': 'large'"
                [labelWeight]="'bold'"
                data-rpa-tag-id="pf-qatr-dropdown">
                  <div accordion-body>
                    <quarterly-after-tax
                      [data]="performanceModel?.performance?.quarterEndAfterTaxRtn"
                      [profileData]="performanceModel?.profileData"
                      [marketPriceFootNote]="performanceModel?.marketPriceFootNote"
                      [performanceFootNote]="performanceModel?.performanceFootnote"></quarterly-after-tax>
                  </div>
                </c11n-accordion>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-4 col-sm-10 col-lg-5">
                <div *ngIf="performanceModel && performanceModel.profileData; else noTableData">
                    <h5 class="rps-heading-five"
                        *ngIf="!performanceModel?.profileData?.isExternal && (performanceModel?.profileData?.isETF || performanceModel?.profileData?.is529 || (performanceModel?.profileData?.isMutualFund && !performanceModel?.profileData?.isFundOfFunds))">
                        Expense ratio<sup
                            *ngIf="performanceModel?.profileData?.isMarketNeutralFund || this.performanceModel?.profileData?.fundCategoryId === 1416">{{performanceModel?.expenseRatioFootnote?.id-1}}</sup>
                    </h5>
                    <h5 class="rps-heading-five"
                        *ngIf="!performanceModel?.profileData?.isExternal && (performanceModel?.profileData?.isMutualFund && performanceModel?.profileData?.isFundOfFunds)">
                        Acquired fund fees and expenses<sup>{{performanceModel?.expenseRatioFootnote?.id-1}}</sup></h5>
                    <h5 class="rps-heading-five" *ngIf="performanceModel?.profileData?.isExternal">Gross Expense Ratio
                    </h5>
                    <span class="no-data" *ngIf="performanceModel?.expenseRatio; else noTableData">
                    <div class="expense-ratio">
                        <p class="rps-paragraph-one">{{ performanceModel?.profileData?.is529 ?
                            performanceModel?.profileData?.shortName : performanceModel?.profileData?.ticker |
                            DashIfEmpty }}<sup
                                *ngIf="performanceModel?.profileData?.ticker=='VPGDX'">{{performanceModel?.performanceFootnote?.id}}</sup>
                        </p>
                        <p class="rps-paragraph-one" data-rpa-tag-id="pf-expr-expenseRatio">{{ performanceModel?.expenseRatio |
                            VMFPercent:true | DashIfEmpty }}</p>
                    </div>
                    <div class="expense-ratio" *ngIf="!performanceModel?.profileData?.is529">
                        <p class="rps-paragraph-one">Average expense ratio of similar
                            funds<sup>{{performanceModel?.expenseRatioFootnote?.id}}</sup></p>
                        <p class="rps-paragraph-one" data-rpa-tag-id="expenseRatioAvg">{{
                            performanceModel?.avgExpenseRatio | VMFPercent: true | DashIfEmpty }}</p>
                    </div>
                    </span>
                </div>
            </div>
            <ng-template #noTableData>
                <p class="no-data">This information is temporarily unavailable.</p>
            </ng-template>

            <div class ="col-xs-4 col-sm-10 col-lg-5">
                <div>
                    <historical-measures [performanceModel]="performanceModel"
                        [benchmarkFootNote]="performanceModel?.benchmarkFootnote"
                        [rSquaredBetaFootnote]="performanceModel?.rSquaredBetaFootnote"
                        [isValidSinceInceptionDate]="isValidSinceInceptionHideChart()"></historical-measures>
                </div>
            </div>
        </div>

        <div class="row"
            *ngIf="(!performanceModel?.profileData?.isETF || performanceModel?.profileData?.is529 || performanceModel?.profileData?.isExternal) && !(performanceModel?.profileData?.isETF && performanceModel?.profileData?.isExternal)">
            <div *ngIf="!performanceModel?.profileData?.isETF" class="col-xs-4 col-sm-10 col-lg-5">
                <fees [profileData]="performanceModel?.profileData" [feeData]="performanceModel?.fees"></fees>
            </div>
            <div class ="col-xs-4 col-sm-10 col-lg-5"
            *ngIf="performanceModel?.profileData?.is529 || performanceModel?.profileData?.isExternal">
            <minimums [minimum]="performanceModel?.minimum" [minimums]="performanceModel?.minimums"
                    [is529]="performanceModel?.profileData?.is529"></minimums>
            </div>
        </div>

        <div class="row" *ngIf="performanceModel?.profileData?.isMutualFund">
            <div class="col-xs-4 col-sm-12">
                <p class="link bold-link" [innerHTML]="accountServiceFees?.contentValue"></p>
            </div>
        </div>
        <div *ngIf="performanceModel?.profileData?.isETF" class=" performance-footnote">
            <div class="col-xs-4 col-sm-12">
                <p class="note-text rps-paragraph-one rps-grey" [innerHTML]="pastPerformanceEtf?.contentValue"></p>
            </div>
        </div>
        <div *ngIf="performanceModel?.profileData?.isMutualFund" class=" performance-footnote">
            <div class="col-xs-4 col-sm-12">
                <p class="note-text rps-paragraph-one rps-grey" [innerHTML]="pastPerformanceMf?.contentValue"></p>
            </div>
        </div>
        <div *ngIf="performanceModel?.profileData?.is529" class="performance-footnote">
            <div class="col-xs-4 col-sm-12">
                <p class="note-text rps-paragraph-one rps-grey" [innerHTML]="pastPerformance529?.contentValue"></p>
            </div>
        </div>
        <div *ngIf="performanceModel?.profileData?.isExternal && !performanceModel?.profileData?.isETF" class="accountProfile">
            <h5 class="total-returns rps-heading-five">Account Profile</h5>
        </div>
        <div *ngIf="performanceModel?.profileData?.isExternal && !performanceModel?.profileData?.isETF" class="row padBottom">
            <div class="col-xs-4 col-sm-10 col-lg-5 fundOption">
                <vmf-fund-options [performanceModel]="performanceModel"></vmf-fund-options>
            </div>

            <div class="col-xs-4 col-sm-10 col-lg-5 tradingBottom">
                <vmf-trading-cutoff [performanceModel]="performanceModel"></vmf-trading-cutoff>
            </div>

            <div style="padding-bottom: 0px !important;" class="col-xs-4 col-sm-10 col-lg-5">
                <vmf-settlement-date [performanceModel]="performanceModel"></vmf-settlement-date>
            </div>
        </div>
    </div>
</section>
